import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Bangladeshi National ID validator following Single Responsibility Principle
 */
export class BdValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Bangladeshi National ID',
      pattern: /^\d{10}|\d{13}|\d{17}$/,
      minLength: 10,
      maxLength: 17
    });
  }

  validateFormat(id) {
    // Check length (can be 10, 13, or 17 digits)
    if (![10, 13, 17].includes(id.length)) {
      return ValidationResult.invalid('Bangladeshi NID must be 10, 13, or 17 digits');
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Bangladeshi NID must contain only digits'
    );
  }

  validateChecksum(id) {
    // Bangladeshi NID doesn't have a standard checksum algorithm
    // Basic validation for reasonable number ranges
    if (id.length === 10) {
      const idNum = parseInt(id);
      if (idNum < 1000000000) {
        return ValidationResult.invalid('Invalid 10-digit NID format');
      }
    }

    return ValidationResult.valid('Valid Bangladeshi NID');
  }
}